export default __webpack_public_path__ + "static/media/sprintxCourierSample.7f2acf4f.csv";